import React, { Component } from 'react'
import Event from './Event'
// import Change from './Change'

import './TimeLine.css'

class TimeLine extends Component {


    render() {

        const { background, events } = this.props

        const timelineStyles = {
            background
        }

        return (

            <div className="timeline" style={timelineStyles}>

                <div className="path"></div>

                {events.map((event, index) => {

                    let offset = index % 2 === 0 ? false : true

                    return <Event key={index} {...event} offset={offset} />

                    // return !event.isChange ? <Event key={index} {...event} offset={offset} /> :  <Change key={index} {...event} offset={offset} />

                })}



            </div>

        );
    }
}


export default TimeLine;